import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MessageType } from '../../../shared/constants/message-type.enum';
import { LoggerService } from '../logger/logger.service';
import { Language } from '../../../shared/constants/language.enum';
import { LogsType } from '../../../shared/constants/logs-type.enum';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private readonly className = 'MessageService';
  private functionName = '';

  constructor(
    private readonly translate: TranslateService,
    private readonly toastr: ToastrService,
    private readonly logger: LoggerService
  ) { }

  /**
   * Get  message from translation file
   *
   * @param key
   * @returns Promise<string>
   */
  private getMessage(key: string): Promise<string> {
    const language = localStorage.getItem('lang') ?? Language.PT;
    this.translate.use(language);

    return new Promise((resolve, reject) => {
      this.translate.get(key).subscribe({
        next: (translatedMessage: string) => resolve(translatedMessage),
        error: (error) => reject(new Error (error))
      });
    });
  }

  getErrorMessage(key: string): Promise<string> {
    const errorKey = 'message.' + MessageType.ERROR + '.' + key;

    return this.getMessage(errorKey);
  }

  /**
   * Show messages in a toast
   *
   * @param key
   * @returns void
   */
  showMessages(key: string, type: MessageType): void {
    this.functionName = 'showMessages';
    const errorKey = 'message.' + type + '.' + key;
    this.getMessage(errorKey).then(message => {
      switch(type) {
        case MessageType.ERROR:
          this.toastr.error(message, '');
          break;
        case MessageType.WARNING:
          this.toastr.warning(message, '');
          break;
        case MessageType.SUCCESS:
          this.toastr.success(message, '');
          break;
        default:
          this.toastr.info(message, '');
          break;
      }
    }).catch(error => {
      this.logger.logMessage(LogsType.ERROR, this.className, this.functionName, 'Resultado:', error);
    });
  }

  showMessage(message: string, type: MessageType): void {
    switch(type) {
      case MessageType.ERROR:
        this.toastr.error(message, '');
        break;
      case MessageType.WARNING:
        this.toastr.warning(message, '');
        break;
      case MessageType.SUCCESS:
        this.toastr.success(message, '');
        break;
      default:
        this.toastr.info(message, '');
        break;
    }
  }
}
